module.exports = __webpack_public_path__ + "img/logo_header_mob.aa4ee7ef.png";